export const AUTOMATON_OVERRIDE = 'AUTOMATON_OVERRIDE';
export const AUTOMATON_PROCESS = 'AUTOMATON_PROCESS';
export const AUTOMATON_RESET = 'AUTOMATON_RESET';
export const AUTOMATON_RESIZE = 'AUTOMATON_RESIZE';
